import React from 'react';
import { CardSkeleton } from 'src/modules/shared/components/atoms/cards/card-skeleton';

interface ToolsGridSkeletonProps {
  count?: number;
  showHeaderAction?: boolean;
}

export const ToolsGridSkeleton: React.FC<ToolsGridSkeletonProps> = ({
  count = 3,
  showHeaderAction = true,
}) => {
  return (
    <>
      {Array.from({ length: count }).map((_, idx) => (
        <CardSkeleton
          key={idx}
          header={{ title: true, action: showHeaderAction }}
          content={{ lines: 2, widths: ['w-full', 'w-3/4'] }}
          variant="secondary"
        />
      ))}
    </>
  );
};
